import React from 'react'
import classes from './ScreenItem.module.sass'

type Props = {
  image?: string
  alt?: string
  showScreenModal: (image: string) => void  
}

const ScreenItem = ({ image, alt, showScreenModal }: Props) => {
  if (image)
    return (
      <div
        className={classes.Container}
        style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover' }}
        onClick={() => {
          showScreenModal(image)
        }}
      >
        <div className={classes.Button}></div>
      </div>
    )
  return <></>
}

export default ScreenItem
